var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10283a;}.cls-2{fill:#173856;}.cls-3{fill:#fbbcaa;}.cls-4{fill:#20456e;}.cls-5{fill:#639;}.cls-6{fill:#442114;}.cls-7{fill:#2b120a;}.cls-8{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 2 F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "haut_2_f",
    "data-name": "haut 2 f"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "501 895 501 965 568 965 568 891 501 895"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1007,1248l-2,183c-6-48-95-51-99-1l11-178Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M906,1430v79c0,35.19,99,35.19,99,0v-75C1007.15,1380.76,908.15,1376.76,906,1430Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1098,1252l-5,287c0,14-80,14-80,0l-8.67-199.1,2.42-87.9Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M876,1198.8c5.12-18.42,62.12-6.06,57,12.37,0,0-3,33.56-37,28.26S876,1198.8,876,1198.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M933,1019.54c-22.58.39-40.5,9.34-49,35.46l-12,135c0,36,58,40,58,13Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M916.82,1252.5v-203s0-50,90.59-50,90.59,40,90.59,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 400,
    y: 633,
    width: 181,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1199.41,836.19c-14-20.19-23.41-3.79-23.41-5.69a169,169,0,0,0-168.59-169H1007a169,169,0,0,0-168.59,169c0,1.9-9.41-14.5-23.41,5.69-7.72,11.13-8.89,57.77,9,76.81,14.55,15.49,33,24,45.38,15A168.78,168.78,0,0,0,1007,999.49h.41A168.78,168.78,0,0,0,1145,928c12.38,9,30.83.45,45.38-15C1208.3,894,1207.13,847.32,1199.41,836.19Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1189.6,788c-13.32-102.49-102.36-142.91-182.85-140.59-80.48-2.32-169.52,38.1-182.84,140.59C822,830,829,827,839,830c8.21,33.38,14.41,77,32,100a223.08,223.08,0,0,0,24.17,27A169.09,169.09,0,0,0,939,987c31.06,15,54,14,67.75,12.8,13.73,1.25,36.7,2.15,67.76-12.8a169.09,169.09,0,0,0,43.83-30,223.08,223.08,0,0,0,24.17-27c17.59-23,23.79-66.62,32-100C1184.51,827,1191.51,830,1189.6,788Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1009,1000c-27.21-1-45.67,2.64-60,9.5,13.68,11,34.89,10.5,60,10.5s46.32.48,60-10.5C1054.67,1002.64,1036.21,999,1009,1000Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1006.75,647.41c0-2.87.25-19.41.25-21.41-34,0-81,4-90.86,38.25-46.49,20.4-84,60.11-92.23,123.75C822,830,829,827,839,830c8.21,33.38,14.41,77,32,100a223.08,223.08,0,0,0,24.17,27A169.09,169.09,0,0,0,939,987c31.06,15,54,14,67.75,12.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M916,664c-7.31,127.57,22.78,202.9,85,215C946,811.1,916.13,739.65,916,664Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1006,647.41c0-2.87-.25-19.41-.25-21.41,34,0,81,4,90.87,38.25,46.49,20.4,84,60.11,92.22,123.75,1.91,42-5.09,39-15.09,42-8.21,33.38-14.4,77-32,100a222.24,222.24,0,0,1-24.17,27,168.92,168.92,0,0,1-43.83,30c-31.06,15-54,14-67.75,12.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1096.92,664c7.31,127.57-22.78,202.9-85,215C1067,811.1,1096.79,739.65,1096.92,664Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1083,1016.54c22.58.39,40.5,9.34,49,35.46l28,148c-14,24-49,33-62,18Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1150.75,1209c-1.24-8.77-45.49,3.82-44.82,11,0,0,2.36,29.89,29.1,25.17S1150.75,1209,1150.75,1209Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpFrame2);
export default __webpack_public_path__ + "static/media/up_frame_2.26ebaaf7f53225713ab563a3d189521c.svg";
export { ForwardRef as ReactComponent };